/** Roster list order without a lineup column: when they were added to the team. */

export const sortTeamAssignments = (assignments = []) =>
  [...assignments].sort((a, b) => {
    const createdA = String(a?.created || "");
    const createdB = String(b?.created || "");
    if (createdA !== createdB) return createdA < createdB ? -1 : 1;
    return String(a?.id || "").localeCompare(String(b?.id || ""));
  });
